
import ExplainerTable from "./explainerTable";
import { formatLatency } from '@circuitry-ai/doc-ui';

const Explainerranking = ({ rankingList, advisor_id, details }: any) => {


    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col">
                <div className="flex w-full flex-row items-center justify-between">
                <div className="font-medium text-lg">Reranked document snippet</div>
                {details?.time_taken_reranker && <div className="text-sm"><span className="font-medium">Time Taken:</span> {details?.time_taken_reranker} S</div>}
                </div>
                <div className="flex w-full flex-row items-center justify-between">
                <div className="text-sm font-normal mt-1">Narrow down the pool of searchable documents by applying filters based on metadata</div>
                {details?.llm_model_reranker && <div className="text-sm"><span className="font-medium">LLM Model:</span> {details?.llm_model_reranker}</div>}
                </div>
            </div>
            {details?.reranker_latency !== undefined && details?.reranker_latency !== null && details?.reranker_latency !== '' && (
                <div>
                    <span>Reranker Latency: {formatLatency(details.reranker_latency)} </span>
                </div>
            )}
            <ExplainerTable rowData={rankingList} advisor_id={advisor_id} tab="ranking"/>
        </div>
    )
}


export default Explainerranking;